import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Link as MuiLink, Tooltip, Typography } from '@mui/material';

import { opportunityOfferBuilderLink } from './accountRelatedModel';

interface Props {
  // undefined while the offer lookup is loading or has failed, so no tip claims there is no offer
  hasOffer?: boolean;
  opportunity: App.OpportunityPage;
}

export default function AccountOpportunityName({ hasOffer, opportunity }: Props) {
  const name = opportunity.opportunity_info?.name || opportunity.id;
  const { isLinked, tooltip } = opportunityOfferBuilderLink(hasOffer, opportunity.opportunity_info?.campaign_type__c);

  if (isLinked) {
    return (
      <MuiLink component={Link} to={`/offers/${opportunity.id}/offer-builder`} fontWeight={600} underline="hover">
        {name}
      </MuiLink>
    );
  }

  const plainName = (
    <Typography component="span" fontWeight={600}>
      {name}
    </Typography>
  );

  return tooltip ? <Tooltip title={tooltip}>{plainName}</Tooltip> : plainName;
}
